import * as React from 'react';
import { colors } from '../../../index';

const IconAddUser = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "-0.155 -0.199 13.942 12.217",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.767 6.463h4.69c1.501 0 2.768 1.093 2.768 2.376v2.993H0V8.838c0-1.282 1.266-2.375 2.767-2.375zm10.881-2.329c0 .285-.234.57-.562.57H12.1v.998c0 .285-.282.57-.563.57a.574.574 0 01-.563-.57v-.998H9.99a.574.574 0 01-.563-.57c0-.333.235-.57.563-.57h.985V2.518c0-.285.234-.57.563-.57.281 0 .563.285.563.57v1.046h.985c.328 0 .562.238.562.57zM5.112 0C6.66 0 7.926 1.283 7.926 2.851S6.66 5.702 5.112 5.702c-1.547 0-2.814-1.283-2.814-2.85C2.298 1.282 3.564 0 5.112 0z"
  }));
};

export default IconAddUser;